"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var TxpOption_1 = require("owa-txp-option/lib/TxpOption");
var loadCalendarMailboxConfiguration_1 = require("./loadCalendarMailboxConfiguration");
/**
 * Automatic processing subcategory settings
 */
var automaticProcessingSubCategory = {
    key: 'automaticProcessing',
    titleStringKey: 'optionSubcategory_automaticProcessing',
    options: [TxpOption_1.default],
    onSelected: loadCalendarMailboxConfiguration_1.default,
};
exports.default = automaticProcessingSubCategory;
//# sourceMappingURL=automaticProcessingSubCategory.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/config/calendar/owa-options-calendar/lib/data/automaticProcessingSubCategory.js
// module id = 5265
// module chunks = 2